import { defineStore } from 'pinia';
import { SearchModes } from './constStore';

export const useRootStore = defineStore('root', {
  state: () => ({
    searchMode: SearchModes.NONE,
    isLoading: false
  }),
  actions: {
    updateSearchMode(mode) {
      if (Object.values(SearchModes).includes(mode)) {
        this.searchMode = mode;
      } else {
        this.searchMode = SearchModes.NONE;
      }
    },
    updateLoading(val) {
      this.isLoading = val;
    }
  }
});
